module.exports = "//public.getcloudapp.com/packs/media/images/icons-toggle-open-918bc6ed6f9e5b8cb5a1b78390d80d47.svg";